// Copyright ©️ 2026 eVolve MEP, LLC

import type { HexTriplet } from '@evolvemep/api-ts';

import highlightSvg from 'assets/icons/icon-src/markup/highlight.svg?raw';
import {
  BaseMarkupTool,
  type MarkupToolContext,
  type PanelConfig,
} from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';

const { Autodesk } = window;

export class HighlightTool extends BaseMarkupTool {
  readonly type = 'highlight'; // Matches the existing type used by Autodesk's highlight markup tool, which we build on top of.

  constructor(context: MarkupToolContext) {
    super(context, {
      strokeWidth: 24,
      strokeColor: '#FFFF00' as HexTriplet, // Bright yellow highlight color.
      strokeOpacity: 50,
    });
  }

  protected getPanelConfig(): PanelConfig {
    return {
      panelTitle: 'Highlight',
      sections: [
        {
          heading: 'Outline',
          fields: [
            { property: 'stroke-width', label: 'Size' },
            { property: 'stroke-color', colorLabel: 'Color', opacityLabel: 'Opacity' },
          ],
        },
      ],
    };
  }

  protected activateEditMode() {
    const highlightEditMode = new Autodesk.Viewing.Extensions.Markups.Core.EditModeHighlight(this.markupExtension);
    this.markupExtension.changeEditMode(highlightEditMode);
  }

  protected readonly buttonIcon = highlightSvg;
  protected readonly buttonTooltip = 'Highlight';
}
